import { renderToString } from 'react-dom/server'

const columns = [
  {
    data: 'email',
    className: 'bold',
    render: (data, type, row, meta) => renderToString(
      <a href={`/admin/users/${row.DT_RowId}`}>{data}</a>
    ),
  },
  {
    data: 'roles',
    render: (data, type, row, meta) => renderToString(
      <>
        <span>{row.roles}</span>
        <span className='ellipsis accent'></span>
        <span>{row.organisations}</span>
      </>
    ),
  },
]

const headers = [
  'Email',
  'Roles',
]

const filters = []

const sorters = []

const order = [[ 0, "asc" ]]

export { columns, headers, filters, sorters, order }
